module.exports = __webpack_public_path__ + "576b2277.svg";